import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/InitialPage.css";

export default function InitialPage() {
  const navigate = useNavigate();

  const handleLogin = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tenant");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("restaurants");
    localStorage.removeItem("activeRestaurant");
    localStorage.clear();

    navigate("/login");
  };

  const handleSignup = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tenant");
    localStorage.removeItem("user");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("restaurants");
    localStorage.removeItem("activeRestaurant");
    localStorage.clear();

    navigate("/signup");
  };

  return (
    <div className="initial-wrapper">
      {/* Overlay escuro */}
      <div className="dark-overlay"></div>

      {/* NAVBAR */}
      <header className="initial-navbar">
        <div className="logo-box">
          <img src="/assets/logo-mesaclick.png" className="logo" />
        </div>

        <nav className="nav-menu">
          <button onClick={() => navigate("/sobre")} className="nav-btn">Sobre</button>
          <button onClick={() => navigate("/contato")} className="nav-btn">Contato</button>
          <button onClick={handleLogin} className="nav-btn login-btn">
            Login
          </button>
        </nav>
      </header>

      {/* HERO CONTENT */}
      <div className="hero-container">

        {/* Texto à esquerda */}
        <div className="hero-left">
          <h1 className="hero-title">
            Transforme seu restaurante<br />
            com o MesaClick
          </h1>
          <p className="hero-desc">
            A plataforma inteligente de autoatendimento que facilita pedidos, agiliza a cozinha e melhora a experiência do cliente.
          </p>
        </div>

        {/* Caixa de ação à direita */}
        <div className="hero-right">
          <div className="action-box trial-box">
            <h2>Experimente grátis por 30 dias </h2>

            <p className="trial-desc">
              Teste todas as funcionalidades do MesaClick sem compromisso.
              Cancele quando quiser.
            </p>

            <button className="btn primary" onClick={handleSignup}>
              Criar conta grátis
            </button>

            <p className="selo">✨ Sem cartão de crédito para começar</p>


          </div>


        </div>
      </div>

      <footer className="initial-footer">
        {/*© {new Date().getFullYear()} MesaClick — Desenvolvido pela Faenetech */}
        © {new Date().getFullYear()} MesaClick — By Faenetech Sistemas e Tecnologia

      </footer>
    </div>
  );
}
